import React, { useEffect, useState } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import toastError from "../../errors/toastError";
import api from "../../services/api";

const QueueSelectUnit = ({ selectedQueueIds, onChange, fullWidth = false }) => {
	const [queues, setQueues] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/queue");
				setQueues(data);
			} catch (err) {
				toastError(err);
			}
		})();
	}, []);

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<FormControl
			variant="outlined"
			size="small"
			fullWidth={fullWidth}
			sx={{ minWidth: 200 }}
		>
			<InputLabel id="queue-select-unit-label">Departamento</InputLabel>
			<Select
				labelId="queue-select-unit-label"
				label="Departamento"
				value={selectedQueueIds || ""}
				onChange={handleChange}
			>
				<MenuItem value="">Todos los departamentos</MenuItem>
				{queues.map(queue => (
					<MenuItem key={queue.id} value={queue.id}>
						{queue.name}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default QueueSelectUnit;
